import type { DirectLiveUpdateType } from "@/live-updates/liveUpdateMessage";

export type CoreBookingView =
  "arrivals" | "non-arrivals" | "returns" | "overstays";

export type BookingLiveUpdateType = DirectLiveUpdateType;

export type CoreBookingTabKey = `core:${CoreBookingView}`;
export type BookingTabKey = CoreBookingTabKey;
export type CoreBookingTabUrlValue = CoreBookingView;
export type BookingTabUrlValue = CoreBookingTabUrlValue;

export interface BookingTabDescriptor {
  key: CoreBookingTabKey;
  urlValue: CoreBookingTabUrlValue;
  view: CoreBookingView;
  titleKey: string;
  /** the live updates events that should refresh that particular tab. */
  liveUpdateTypes: ReadonlyArray<BookingLiveUpdateType>;
}

export const DEFAULT_BOOKING_TAB_URL_VALUE: CoreBookingTabUrlValue = "arrivals";

export const CORE_BOOKING_TABS: ReadonlyArray<BookingTabDescriptor> = [
  {
    key: "core:arrivals",
    urlValue: "arrivals",
    view: "arrivals",
    titleKey: "bookings.viewArrivalsButton",
    liveUpdateTypes: ["booking.created", "booking.updated"],
  },
  {
    key: "core:non-arrivals",
    urlValue: "non-arrivals",
    view: "non-arrivals",
    titleKey: "bookings.viewNonArrivals",
    liveUpdateTypes: ["booking.created", "booking.updated"],
  },
  {
    key: "core:returns",
    urlValue: "returns",
    view: "returns",
    titleKey: "bookings.viewReturnsButton",
    liveUpdateTypes: ["booking.updated"],
  },
  {
    key: "core:overstays",
    urlValue: "overstays",
    view: "overstays",
    titleKey: "bookings.viewOverstayButton",
    liveUpdateTypes: ["booking.updated"],
  },
];
